'use client';

import React, { useMemo } from 'react';
import { useProfile } from 'src/context/providers/ProfileProvider';
import WidgetEmpty from 'src/components/Profiles/shared/widgets/shared/WidgetEmpty';

const PREVIEW_MAX_ITEMS = 2;

const CompactProfessionalMixPreview: React.FC = () => {
  const { entityDetails } = useProfile();

  const mixes: { title: string; value: number; filter_id: string }[] =
    entityDetails?.professional_mix || [];

  const sortedMixes = useMemo(
    () =>
      [...mixes]
        .sort((a, b) => a.title.localeCompare(b.title))
        .slice(0, PREVIEW_MAX_ITEMS),
    [mixes]
  );

  if (sortedMixes.length === 0) {
    return <WidgetEmpty data-testid="compact-professional-mix-preview-empty" />;
  }

  return (
    <div
      className="flex flex-col"
      role="list"
      aria-label="Healthcare Professional Mix"
      data-testid="compact-professional-mix-preview"
    >
      {sortedMixes.map((mix, index: number) => (
        <div
          key={`${mix.title}-${index}`}
          className="flex items-center justify-between py-1.5 border-b border-neutral-100 last:border-b-0"
          role="listitem"
        >
          <span className="text-sm font-medium text-primary truncate">
            {mix.title}
          </span>
          <span className="text-sm font-semibold text-secondary flex-shrink-0 ml-2">
            {mix.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CompactProfessionalMixPreview;
